import { render, staticRenderFns } from "./TipsDialog.vue?vue&type=template&id=ef06af56&scoped=true"
import script from "./TipsDialog.vue?vue&type=script&lang=js"
export * from "./TipsDialog.vue?vue&type=script&lang=js"
import style0 from "./TipsDialog.vue?vue&type=style&index=0&id=ef06af56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06af56",
  null
  
)

export default component.exports